import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomOutsideAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomOutsideAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomOutsideAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.oda"
        className="room-form__outside-air"
        label={t("Room.oda")}
        unit="m³/h"
        color="#66c29b"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__outside-air__input"
      />
    )
  }
)
